/* globals angular, _ */
(function() {
  'use strict';

  function ReversesDeleteCtrl ($scope, $rootScope, $uibModalInstance, localStorageService,
    Historico, Perfil, reverse) {

    var $ctrl = this;

    $ctrl.config = {
      loading: {
        panel: true
      }
    };

    $ctrl.reverse = reverse;

    Perfil.getClienteData(localStorageService.get('user').id).then(function(user) {
      $ctrl.user = user;
    });

    $ctrl.confirm = function () {
      $ctrl.config.msgError = false;

      Historico
        .deleteReverse($ctrl.reverse.id)
        .then(function(details) {
          $uibModalInstance.close();
        })
        .catch(function(err) {
          $uibModalInstance.dismiss(err);
        });
    };

    $ctrl.closePanel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }

  angular
    .module('mandaeApp')
    .controller('ReversesDeleteCtrl', ReversesDeleteCtrl);
}());
